import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const TrioDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazane de încălzire <span className={styles.highlight}>TRIO</span></p>
      <p className={styles.text}>
        Cazanele de încălzire TRIO  destinat încălzirii caselor, spațiilor industriale și a altor încăperi înzestrate cu sistem de încălzire centralizata. Pregătirea și furnizarea de căldură pentru necesitățile tehnologice care utilizează drept combustibil lemn de foc, deșeuri lemnoase, cărbune, brichete din rumeguș, coajă de floarea soarelui, semințe, paie, stuf și turba, ruf etc.
      </p>
      <p className={styles.text}>
        Construcția cazanului permite cea mai eficienta utilizare a căldurii generate de arderea diferitelor tipuri de combustibili solizi cu un conținut scăzut de calorii,dar cea mai mare putere termica a cazanului este obținută prin arderea antracitului.
      </p>
      <p className={styles.text}>
        Timpul de ardere în urma unei singure încărcări al combustibilului depinde în mod direct de calitatea acestuia și pierderii de căldură a imobilului încălzit. Exploatarea cazanului se face numai prin alimentarea acestuia în regim manual.
      </p>
      <p className={styles.text}>

      </p>
      <h1 className={styles.title}>Caracteristicile cazanului</h1>
      <p className={styles.text}>
        Carcasa cazanului Altep TRIO este fabricată din oțel certificat de înaltă calitate, cu o grosime de 6 mm pe cele casnice și de 8mm pe cazanele industriale de putere mare, ceea ce garantează o fiabilitate ridicată și o lungă durată de viață a cazanului.
      </p>
      <p className={styles.text}>
        Pentru a proteja împotriva pierderilor, pe suprafața exterioară a cazanului, sub carcasa decorativă avem un strat de material izolant termic. Carcasa însăși este realizată din tablă de oțel, acoperită cu un strat de vopsea termică, atât pe exterior, cât și pe interior.
      </p>
      <p className={styles.text}>
        Ușile cazanului au paravane reglabil pe un cablu de etanșare, care garantează o fixare strânsă a ușii pe corpul cazanului, astfel evitând pătrunderea gazelor arse în casă și asigurându-o etanșeitatea completă a camerei de ardere.
      </p>
      <p className={styles.text}>
        Cazanele pe combustibil solid TRIO sunt livrate cu două turbine și blocul de comandă. Aceste accesorii vă permit să controlați regimul de funcționare automată a cazanului. Pe părțile laterale ale cazanului sunt montate două mânere speciale pentru reglarea alimentării cu aer în cazan. Aerul este furnizat prin niște duze situate direct în cuptor. O astfel de alimentare cu aer permite arderea combustibilului în straturi, într-un regim econom.
      </p>
      <p className={styles.text}>
        Partea de convecție a cazanului este formată din schimbătorul de căldură combinat dintr-un raft superior orizontal și fântânile verticale. Schimbătorul de căldură este situat în spatele camerei de ardere a cazanului.
      </p>
      <p className={styles.text}>
        Cazanul TRIO are o cameră de ardere de dimensiuni semnificative, ceea ce face posibilă o ardere îndelungată în urma unei singure alimentări cu combustibil. În partea de jos a camerei de ardere se află grătarul din fontă prin care circulă apa. Pe grătar este așezat combustibilul solid. Grătarul este realizat din țevi groase monolit, fără a fi sudate între ele, prin care circulă apa în mod constant.
      </p>
      <p className={styles.text}>
        Gazele arse sunt evacuate prin gura de evacuare de forma pătrată, situată în partea din spate a cazanului.
      </p>
      <p className={styles.text}>
        Un coeficient mare al eficienței cazanului și posibilitatea arderii diferitelor feluri de combustibil solid, ne permite să considerăm aceste cazane drept o alternativă profitabilă și sigură pentru cazanele tradiționale pe gaz și combustibili lichizi.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th colSpan="10">TRIO</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Puterea nominală a cazanului</td>
              <td>kW</td>
              <td>80</td>
              <td>97</td>
              <td>125</td>
              <td>150</td>
              <td>200</td>
              <td>250</td>
              <td>300</td>
              <td>400</td>
              <td>500</td>
            </tr>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>6,7</td>
              <td>7,5</td>
              <td>11,9</td>
              <td>13,0</td>
              <td>16,5</td>
              <td>21,3</td>
              <td>24,6</td>
              <td>26,7</td>
              <td>35,8</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="11">Dimensiuni camera de ardere</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adâncime</td>
              <td>mm</td>
              <td>540</td>
              <td>640</td>
              <td>690</td>
              <td>790</td>
              <td>790</td>
              <td>830</td>
              <td>920</td>
              <td>1010</td>
              <td>1300</td>
            </tr>
            <tr>
              <td>Volum</td>
              <td>dm³</td>
              <td>282</td>
              <td>362</td>
              <td>431</td>
              <td>520</td>
              <td>700</td>
              <td>914</td>
              <td>1167</td>
              <td>1430</td>
              <td>2151</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>260</td>
              <td>340</td>
              <td>500</td>
              <td>560</td>
              <td>670</td>
              <td>790</td>
              <td>1130</td>
              <td>1260</td>
              <td>1550</td>
            </tr>
            <tr>
              <td>Greutatea cazanului fără apă</td>
              <td>kg</td>
              <td>910</td>
              <td>1050</td>
              <td>1520</td>
              <td>1630</td>
              <td>2000</td>
              <td>2300</td>
              <td>2920</td>
              <td>3340</td>
              <td>4100</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="10">100-180</td>
            </tr>
            <tr>
              <td>Temperatura min. a apei recomandata</td>
              <td>°C</td>
              <td colSpan="10">58</td>
            </tr>
            <tr>
              <td>Temperatura max. apa</td>
              <td>°C</td>
              <td colSpan="10">90</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei</td>
              <td>MPa</td>
              <td colSpan="10">0,20</td>
            </tr>
            <tr>
              <td>Consum energie electrică, max.</td>
              <td>W</td>
              <td>210</td>
              <td>210</td>
              <td>210</td>
              <td>210</td>
              <td>320</td>
              <td>490</td>
              <td>490</td>
              <td>810</td>
              <td>840</td>
            </tr>
            <tr>
              <td>Diametru extern gura evacuare</td>
              <td>mm</td>
              <td>245</td>
              <td>299</td>
              <td>299</td>
              <td>299</td>
              <td>348</td>
              <td>398</td>
              <td>448</td>
              <td>498</td>
              <td>548</td>
            </tr>
            <tr>
              <td>Diametrul țevilor conexiune rețea apa</td>
              <td>mm</td>
              <td>65</td>
              <td>65</td>
              <td>65</td>
              <td>65</td>
              <td>80</td>
              <td>80</td>
              <td>100</td>
              <td>100</td>
              <td>125</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="11">Parametri recomandați burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>483</td>
              <td>702</td>
              <td>702</td>
              <td>702</td>
              <td>962</td>
              <td>1256</td>
              <td>1520</td>
              <td>1885</td>
              <td>2380</td>
            </tr>
            <tr>
              <td>Diametrul extern</td>
              <td>mm</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
              <td>450</td>
              <td>500</td>
              <td>550</td>
            </tr>
            <tr>
              <td>Înălțime (minim permisă)</td>
              <td>m</td>
              <td>8</td>
              <td>8</td>
              <td>9</td>
              <td>10</td>
              <td>11</td>
              <td>11</td>
              <td>11</td>
              <td>12</td>
              <td>14</td>
            </tr>
            <tr>
              <td>Diametrul țevii de sub siguranțele supapei</td>
              <td>mm</td>
              <td>25</td>
              <td>25</td>
              <td>40</td>
              <td>40</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>2×50</td>
              <td>2×50</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const TrioDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [1070, 1110, 1140, 1180, 1340, 1480, 1610, 1740, 1970] },
    { param: "H", unit: "mm", values: [1760, 1820, 1840, 1860, 1970, 2080, 2140, 2190, 2160] },
    { param: "H1", unit: "mm", values: [1505, 1565, 1585, 1605, 1715, 1805, 1870, 1890, 1890] },
    { param: "H2", unit: "mm", values: [1250, 1275, 1295, 1315, 1400, 1465, 1492, 1487, 1462] },
    { param: "H3", unit: "mm", values: [220, 220, 230, 230, 230, 230, 230, 230, 230] },
    { param: "L", unit: "mm", values: [1530, 1640, 2070, 2170, 2270, 2310, 2560, 2710, 3100] },
    { param: "L1", unit: "mm", values: [1195, 1315, 1740, 1840, 1880, 1920, 2155, 2325, 2640] }
  ]


  const headers = ["Dimensiuni", "U.M.", "80 kW", "97 kW", "125 kW", "150 kW", "200 kW", "250 kW", "300 kW", "400 kW", "500 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/TrioSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};